import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { BasicGroup } from "config/constants.config";
import { buildUpdatingEstimateBasicItemsSelector } from "store/entities/estimates";

import ItemsWrapper from "../ItemsWrapper/ItemsWrapper";
import { useAssociatedItems } from "common/hooks/useAssociatedItems";
import InfoBanner from "../ItemsStep/InfoBanner";


export default function LaborStep({ estimate, patch }) {
  const laborSelector = useMemo(
    () => buildUpdatingEstimateBasicItemsSelector(BasicGroup.LABOR),
    [estimate.id, estimate.type]
  );
  const labors = useSelector(laborSelector);
  const { loaded } = useAssociatedItems();

  if (!loaded)
    return <div style={{ padding: 24 }}>Loading items...</div>;

  return (
    <>
    {estimate.type !== "siding" && (labors || []).length > 0 && (
      <InfoBanner title="Starter and ridge-cap labor is paid per whole bundle">
        The quantity is the number of starter + ridge-cap bundles in the Materials order (whole bundles only).
        It is recalculated automatically when the estimate is saved, so after changing starter or ridge materials, save and check this line again.
      </InfoBanner>
    )}
    <ItemsWrapper
      estimate={estimate}
      patch={patch}
      data={labors}
      group={BasicGroup.LABOR}
      entityName="labor"
    />
    </>
  );
}
